<template>
    <div  class="footer ">
           <div class="info ">
                <h3 style="margin-left:.1rem">人人奢（深圳）科技有限公司</h3>
                <div class="line"></div>
                <ul class="flex_ul">
                    <li>

                        <p style="margin-top:.1rem;margin-left:.1rem">热线：400-0083166</p>
                        <p style="margin-left:.1rem">版权所有&nbsp&nbsp <a target="_bank" href="http://www.miit.gov.cn/">粤ICP备17128099号</a></p>
                        <p style="margin-left:.1rem">深圳市龙岗区布吉街道吉华路268号文化创意产业园D栋3层</p>
                    </li>
                    <li>
                        <img  src="./../assets/rrsCode.png" alt=""> 

                    </li>
                </ul>
              

              

          </div>
         
    </div>
</template>
<script>
export default {
 
  data () {
    return {
    //    ddqCode:require('./../assets/rrsgzh.jpg'),
    //    rrsCode:require('./../assets/rrsCode.png'),
    
    }
  },
  created () {
    
  },
  mounted () {
   
  },
  updated () {
      
  },
  methods: {
    
  },
 
}
</script>
<style lang="less" scoped>
   .footer{
       
     width: 100%;
     height: 3.2rem;
    background-color: #333333;
     overflow: hidden;
     background-size:100% 3.5rem; 
     color: #ffffff;
    //  position: fixed;
    //  bottom: 0;
    //  left: 0;
     .flex_ul{
           display: flex;
           justify-content: space-around;
           flex-wrap: nowrap;
       }
    .info{
        width: 7.2rem;
        margin: .7rem  auto;
     height: 2rem;
    //  margin-left: .15rem;
    //  margin-top: 0.75rem;
     li{
         font-size: 0;
     }
        h3{
           font-size: .26rem;
        
           text-align: left;
           margin-bottom: -0.1rem;
        }
        .line{
            width: 7.2rem;
            height: 0.02rem;
            background: #ffffff;
            margin: 0.14rem auto;
        }
        p{
            font-size: .2rem;
            text-align: left;
        a{
             color: #ffffff;
        }
        }
    }
    .code{
        width: 2rem;
        height: 100%;
        margin-top: -1.5rem;
        img{
           width: 1rem;
           height: 1rem;
        }
    }
 }
</style>




// WEBPACK FOOTER //
// src/components/footer.vue